/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address as a biomechanical platform`)
};

const es_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El address como plataforma biomecánica`)
};

const de_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ansprechposition als biomechanische Plattform`)
};

const zh_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瞄球站位：生物力学平台`)
};

const ar_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضع التصويب كمنصة ميكانيكية حيوية`)
};

const fr_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse en tant que plateforme biomécanique`)
};

const vi_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address như nền tảng cơ sinh học`)
};

const sw_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimamo wa kulenga mpira kama jukwaa la kibiomekaniki`)
};

const th_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ท่าแอดเดรสในฐานะฐานทางชีวกลศาสตร์`)
};

const bs_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address kao biomehanička platforma`)
};

const ja_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生体力学的な土台としてのアドレス`)
};

const ko_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생체역학적 플랫폼으로서의 어드레스`)
};

const pt_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A posição de address como plataforma biomecânica`)
};

const it_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'address come piattaforma biomeccanica`)
};

const sv_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresspositionen som biomekanisk plattform`)
};

const nl_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De adresseerhouding als biomechanisch platform`)
};

const da_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressepositionen som biomekanisk platform`)
};

const nb_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresseposisjonen som biomekanisk plattform`)
};

const fi_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osoitusasento biomekaanisena alustana`)
};

const pl_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozycja przy piłce jako platforma biomechaniczna`)
};

const ru_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прицеливание как биомеханическая платформа`)
};

const tr_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biyomekanik bir zemin olarak adres pozisyonu`)
};

const hi_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बायोमैकेनिकल आधार के रूप में एड्रेस`)
};

const id_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi address sebagai landasan biomekanis`)
};

const ms_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan address sebagai landasan biomekanik`)
};

const cs_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postoj k míči jako biomechanická platforma`)
};

const el_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η θέση address ως εμβιομηχανική πλατφόρμα`)
};

const he_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עמידת הכיוון כפלטפורמה ביומכנית`)
};

const af_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die aanspreekposisie as biomeganiese platform`)
};

const hu_method_content_step_01_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A megcélzás mint biomechanikai platform`)
};

/**
* | output |
* | --- |
* | "Address as a biomechanical platform" |
*
* @param {Method_Content_Step_01_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_tournament_0_heading(inputs)
	return en_method_content_step_01_detail_tournament_0_heading(inputs)
});